export function isLinkApproved(url, domainWhitelist) {
  try {
    const { host } = new URL(url.startsWith('https://') || url.startsWith('http://') ? url : `https://${url}`)
    const lowerCaseHost = host.toLowerCase()
    return domainWhitelist.some((domain) => domain === lowerCaseHost || lowerCaseHost.endsWith(`.${domain}`))
  } catch (error) {
    return false
  }
}
